import { useRef, useState, useEffect, useCallback } from "react";

const useControlled = ({ controlled, default: defaultProp, name }) => {
  const { current: isControlled } = useRef(controlled !== undefined);
  const [valueState, setValue] = useState(defaultProp);
  const value = isControlled ? controlled : valueState;

  useEffect(() => {
    if (process.env.NODE_ENV !== "production" && isControlled !== (controlled !== undefined)) {
      /* eslint-disable no-console */
      console.error(
        [
          `WF-UI: A component is changing ${isControlled ? "a " : "an un"}controlled ${name} to be ${
            isControlled ? "un" : ""
          }controlled.`,
          "Elements should not switch from uncontrolled to controlled (or vice versa).",
          `Decide between using a controlled or uncontrolled ${name} element for the lifetime of the component.`,
          "More info: https://fb.me/react-controlled-components"
        ].join("\n")
      );
    }
  }, [isControlled, controlled, name]);

  const { current: defaultValue } = useRef(defaultProp);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production" && defaultValue !== defaultProp) {
      /* eslint-disable no-console */
      console.error(
        `WF-UI: A component is changing the default value of an uncontrolled ${name} after being initialized.
           To suppress this warning opt to use a controlled ${name}.`
      );
    }
    /* eslint-disable  react-hooks/exhaustive-deps */
  }, [JSON.stringify(defaultProp)]);

  const setValueIfUncontrolled = useCallback(
    newValue => {
      if (!isControlled) {
        setValue(newValue);
      }
    },
    [isControlled]
  );

  return [value, setValueIfUncontrolled];
};

export default useControlled;
